import {
  NetfondsConsentContext,
  NetfondsConsentEvent,
} from "../netfondsConsentSM";

export const addAccountHoldersToContextAction = (
  context: NetfondsConsentContext,
  event: NetfondsConsentEvent
) => {
  if (event.type !== "INIT") return {};

  return {
    accountHolders: event.accountHolders,
  };
};
